import { ChangeDetectionStrategy, Component, input, Input, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TooltipIconComponent } from '../../../../tooltip-icon/tooltip-icon/tooltip-icon.component';
import { InputSwitchComponent } from '../../../input-switch/input-switch.component';

@Component({
  selector: 'osp-label',
  standalone: true,
  imports: [TooltipIconComponent, InputSwitchComponent, ReactiveFormsModule],
  templateUrl: './label.component.html',
  styleUrl: './label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelComponent {
  @Input()
  set for(value: string) {
    this.$for.set(value);
  }

  protected $isRequired = signal(false);

  get for(): string {
    return this.$for();
  }
  tooltip = input<string>();
  switchControl = input<FormControl>();
  protected $for = signal<string>('');

  setRequired(isRequired: boolean): void {
    this.$isRequired.set(isRequired);
  }
}
